import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

const swalPlugin = {};

swalPlugin.install = function(Vue) {
  Vue.prototype.$swal = swal;

  Vue.prototype.$lock = function (message) {
    (message===undefined)&&(message=this.$t("app.promps.wait"))

    this.$swal.fire({
      title: message,
      html:
        '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
      showConfirmButton: false
    });
  }
};

export default swalPlugin;
